// import dependencies
import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';

import {
    PATH_MARKETING_CONTACT_PAGE,
    SALES_PHONE_NUMBER_FORMATTED
} from '~/common/utils/consts';

import Warning from '~/common/images/warning.svg';

import CommonButton from '~/common/components/CommonButton';

// import stylesheet
import styles from './user-count-error.css';

@inject('loginStore', 'convertToPaidStore')
@observer
export default class extends Component {
    render() {
        const {
            convertToPaidStore,
            loginStore: { userCount }
        } = this.props;
        return (
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <img className={styles.icon} src={Warning} />
                    <div>
                        <p>Your account currently has <b>{userCount} users</b>,
                            {userCount > 6
                                ?
                                <Fragment> which is more than these plans support. To complete your purchase you can contact us at {SALES_PHONE_NUMBER_FORMATTED}.</Fragment>
                                :
                                <Fragment> To complete your purchase, you must select the {userCount <= 3 ? <span><b>Partnership</b> or </span> : ''}<b>Small Team</b> plan, or you can <a href={PATH_MARKETING_CONTACT_PAGE} target="_blank">contact us</a> to remove users from your account.</Fragment>
                            }
                        </p>
                    </div>
                </div>
                <CommonButton
                    alternateColor={true} modifier={styles.button}
                    onClick={() => convertToPaidStore.setPlanWithNotEnoughUsersError(false)}
                >
                    OK
                </CommonButton>

            </div>
        );
    }
}

